import { cn } from "toptaal-shared"

interface NotificationProps {
  count: number
  className?: string
}

export function NotificationCount({ count, className }: NotificationProps) {
  const displayNotificationCount = count > 99 ? "99+" : count

  return (
    <p
      className={cn(
        "bg-secondary-coral rounded-full size-6 flex items-center justify-center text-xs text-primary-text-on-bg font-bold",
        className,
      )}
    >
      {displayNotificationCount}
    </p>
  )
}
